export const STATUS_UPDATED = [
  { displayText: "Past hour", key: "past_hour" },
  { displayText: "Today", key: "today" },
  { displayText: "Yesterday", key: "yesterday" },
  { displayText: "Last 7 days", key: "last_7_days" },
  { displayText: "Last 30 days", key: "last_month" },
  { displayText: "Last 6 months", key: "last_6_months" },
  { displayText: "Last 12 months", key: "last_12_months" },
]
